import { render } from "./CartPage.vue?vue&type=template&id=0716697a"
import script from "./CartPage.vue?vue&type=script&lang=js"
export * from "./CartPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/3nb/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Demo/CartPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0716697a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0716697a', __exports__)) {
    console.log('reload')
    api.reload('0716697a', __exports__)
  }
  
  module.hot.accept("./CartPage.vue?vue&type=template&id=0716697a", () => {
    console.log('re-render')
    api.rerender('0716697a', render)
  })

}


export default __exports__